/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBroomDust = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M9.599 4.1c-.582.21-1.007.727-1.196 1.101l-.477.944-.915-.529c-1.118-.645-2.407-.264-3.145 1.014l-1.732-1c1.042-1.805 3.04-2.77 5.013-2.132.41-.498.997-.998 1.772-1.278 1.297-.47 2.86-.23 4.557 1.107L12.24 4.898c-1.295-1.019-2.144-.977-2.641-.798zm5.238 6.436 6.83-6.829-1.415-1.414-6.829 6.829c-2.402-1.77-5.748-1.735-7.871.388l-3.966 3.966 8.897 8.897 3.966-3.966c2.123-2.123 2.159-5.469.388-7.871zm-2.068.654c1.726 1.726 1.747 4.322.265 5.803l-2.551 2.552-1.069-1.069 2.728-2.728-1.414-1.414L8 17.062 6.98 16.04l2.727-2.728L8.293 11.9l-2.728 2.728-1.15-1.15 2.55-2.552c1.482-1.482 4.078-1.46 5.804.265zm7.863 5.521c.497-.41.998-.997 1.278-1.771.47-1.298.23-2.86-1.107-4.558l-1.572 1.236c1.02 1.295.978 2.145.798 2.642-.21.581-.727 1.006-1.1 1.195l-.944.477.528.915c.646 1.118.265 2.407-1.013 3.145l1 1.732c1.805-1.042 2.769-3.04 2.132-5.013z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBroomDust as BroomDust };
